import "../../CommonImports";
import "../../Core/core.css";
import "./Dialog.css";
import * as React from "react";
import { DialogInternal } from "./DialogInternal";
export class Dialog extends React.Component {
    render() {
        return React.createElement(DialogInternal, Object.assign({}, this.props, { modal: true }));
    }
}
